import { AccountDetails } from 'clientServerShared/types/account';
import { FlagshipProvider as SDKFlagshipProvider } from '@flagship.io/react-sdk';
import { useFlagshipProvider } from 'projects/sharedComponents/src/flagship/flagshipProviderHooks';

export type FlagshipProviderProps = {
  accountDetails: AccountDetails;
};

export const FlagshipProvider: React.FC<FlagshipProviderProps> = ({ accountDetails, children }) => {
  const { apiKey, envId, visitorContext, hasUserLoaded } = useFlagshipProvider(accountDetails);

  if (!hasUserLoaded) {
    return <>{children}</>;
  }

  return (
    <SDKFlagshipProvider
      envId={envId}
      apiKey={apiKey}
      visitorData={visitorContext}
      decisionMode="Bucketing"
      pollingInterval={60}
      fetchNow={true}
      activateNow={true}
    >
      {children}
    </SDKFlagshipProvider>
  );
};
